import React, { useEffect, useState } from 'react';
import { ArrowLeftIcon, MenuIcon } from 'lucide-react';
import { useEvent } from '../../contexts/EventContext';
import { useLanguage } from '../../contexts/LanguageContext';
interface HeaderProps {
  onBack?: () => void;
  showBackButton?: boolean;
  onMenuClick?: () => void;
  pageTitle?: string;
  pageSubtitle?: string;
  showEventInfo?: boolean;
}
export function Header({
  onBack,
  showBackButton = false,
  onMenuClick,
  pageTitle,
  pageSubtitle,
  showEventInfo = true
}: HeaderProps) {
  const {
    currentEvent
  } = useEvent();
  const {
    isRTL
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const getTextColor = () => {
    if (currentEvent.id === 'active') {
      return '#17313a';
    }
    return 'white';
  };
  const textColor = getTextColor();
  return <header className="sticky top-0 z-40 w-full border-b shadow-sm transition-all duration-300" style={{
    backgroundColor: currentEvent.colors.primary,
    borderBottomColor: 'transparent',
    color: textColor,
    height: '88px'
  }} data-id="element-3667">
      <div className="px-4 h-full flex items-center" data-id="element-3668">
        <div className="flex items-center justify-between w-full" data-id="element-3669">
          <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-3670">
            {showBackButton && onBack && <button onClick={onBack} className="p-2 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors flex-shrink-0" data-id="element-3671">
                <ArrowLeftIcon className="w-5 h-5" style={{
              transform: isRTL ? 'rotate(180deg)' : 'none'
            }} data-id="element-3672" />
              </button>}
            <div className="min-w-0 flex-1" data-id="element-3673">
              {pageTitle ? <>
                  <h1 className="text-xl font-bold font-gotham truncate" data-id="element-3674">
                    {pageTitle}
                  </h1>
                  {pageSubtitle && <p className="text-sm font-gotham opacity-90 truncate" data-id="element-3675">
                      {pageSubtitle}
                    </p>}
                </> : showEventInfo ? <>
                  <h1 className="text-xl font-bold font-gotham truncate" data-id="element-3676">
                    {currentEvent.name}
                  </h1>
                  <div className={`overflow-hidden transition-all duration-300 ${isScrolled ? 'max-h-0 opacity-0' : 'max-h-10 opacity-100'}`} data-id="element-3677">
                    <p className="text-xs font-gotham opacity-70 truncate" data-id="element-3678">
                      {currentEvent.location}
                    </p>
                    <p className="text-xs font-gotham opacity-60 truncate" data-id="element-3679">
                      {currentEvent.dates}
                    </p>
                  </div>
                </> : null}
            </div>
          </div>

          <button onClick={onMenuClick} className={`p-2 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors flex-shrink-0 ${isRTL ? 'mr-2' : 'ml-2'}`} data-id="element-3680">
            <MenuIcon className="w-6 h-6" data-id="element-3681" />
          </button>
        </div>
      </div>
    </header>;
}